export const CHANGE_IN_VALUE = 'changeInValue';
export const CURRENT_NET_WORTH = 'currentNetWorth';
export const PREVIOUS_VALUE = 'previousValue';
